module.exports = __webpack_public_path__ + "img/icon1@2x.a524e616.png";